// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"480":"bfb4b334e0cac30c","888":"a4746dab74bd3386"}[chunkId] + ".css";
};